import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { Toast, ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Subscription } from 'rxjs/Subscription';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { AuthService } from '../service/auth.service';
import { BudgetService } from '../service/budget.service';
import { CommonService } from '../service/common.service';
import { CompanyService } from '../service/company.service';
import { EnterpriseService } from '../service/enterprise.service';
import { HomeService } from '../service/home.service';
import { ProjectService } from '../service/project.service';
import { ShareholderService } from '../service/shareholder.service';

import { AddCompanyModalComponent } from './addCompanyModal/addCompanyModal.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private homeService: HomeService,
    private EnterpriseService: EnterpriseService,
    private companyService: CompanyService,
    private commonService: CommonService,
    private projectService: ProjectService,
    private budgetService: BudgetService,
    private auth: AuthService,
    private shareholderService: ShareholderService,
    vRef: ViewContainerRef,
    private toastr: ToastsManager
  ) {
    this.projectId = localStorage.getItem('projectId');
    this.toastr.setRootViewContainerRef(vRef);
    this.showInstructions = false;

    const userObj = this.homeService.userInfo;
    this.firstname = new FormControl(userObj.firstname, [
      Validators.maxLength(20),
      Validators.pattern(/^((?=.*[a-zA-Z])[A-Za-z-'_'\s]+)$/),
    ]);
    this.lastname = new FormControl(userObj.lastname, [
      Validators.maxLength(20),
      Validators.pattern(/^((?=.*[a-zA-Z])[A-Za-z-'_'\s]+)$/),
    ]);
    this.phone = new FormControl(userObj.phone);
    this.email = new FormControl(userObj.email, [
      Validators.pattern(
        /^(([^<>()\[\]\\.,;: \s@']+(\.[^<>()\[\]\\.,;: \s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ),
    ]);
    this.address1 = new FormControl(userObj.address1);
    this.address2 = new FormControl(userObj.address2);
    this.state = new FormControl(userObj.state, [
      Validators.pattern(/^((?=.*[a-zA-Z])[A-Za-z-'_'\s]+)$/),
    ]);
    this.city = new FormControl(userObj.city, [
      Validators.pattern(/^((?=.*[a-zA-Z])[A-Za-z-'_'\s]+)$/),
    ]);
    this.zipcode = new FormControl(userObj.zipcode);

    this.form = this.fb.group({
      firstname: this.firstname,
      lastname: this.lastname,
      email: this.email,
      phone: this.phone,
      address1: this.address1,
      address2: this.address2,
      state: this.state,
      city: this.city,
      zipcode: this.zipcode,
    });
  }

  @Input() print: boolean;

  // DECLARATION OF VARIABLES TO COMMUNICATE B/W PARENT AND CHILD
  @ViewChild('companyModal') companyModal: AddCompanyModalComponent;

  // DECLARATION OF ALL VARIABLES
  form: FormGroup;

  companyForm: FormGroup;

  currentUser: any;

  firstname: FormControl = null;

  lastname: FormControl = null;

  address1: FormControl = null;

  address2: FormControl = null;

  phone: FormControl = null;

  city: FormControl = null;

  state: FormControl = null;

  email: FormControl = null;

  zipcode: FormControl = null;

  addComVal: false;

  companyname: FormControl = null;

  projectname: FormControl = null;

  companyArray: any = [];

  projectsArray: any = [];

  showCompany: any = false;

  companyId: string;

  projectId: string;

  isEdit: string;

  private subscription: Subscription;

  showInstructions: boolean;

  ngOnInit() {
    if (this.auth.getToken()) {
      if (this.auth.isLogin()) {
        this.currentUser = localStorage.getItem('userId');
        this.getUserData();
        this.showCompanies();
        this.subscription = this.commonService.notifyObservable$.subscribe((res) => {
          if (res.hasOwnProperty('option') && res.option === 'company_add') {
            this.showCompanies();
          }
        });
      } else {
        localStorage.clear();
        window.location.href = environment.logoutRedirectUrl;
      }
    } else {
      localStorage.clear();
      window.location.href = environment.logoutRedirectUrl;
    }
  }

  // GET USERS SAVED DATA FROM DB
  getUserData() {
    this.homeService.getUser().subscribe(
      (users) => {
        let userObj = this.homeService.userInfo;
        userObj = users.data;
        this.firstname.setValue(
          (userObj.firstname &&
            userObj.firstname[0] &&
            userObj.firstname[0].toUpperCase() + userObj.firstname.slice(1)) ||
            ''
        );
        this.lastname.setValue(
          (userObj.lastname &&
            userObj.lastname[0] &&
            userObj.lastname[0].toUpperCase() + userObj.lastname.slice(1)) ||
            ''
        );
        this.email.setValue((userObj.email && userObj.email.toLowerCase()) || '');
        this.phone.setValue(userObj.phone);
        this.address1.setValue(userObj.address1);
        this.address2.setValue(userObj.address2);
        this.state.setValue(
          (userObj.state[0] && userObj.state[0].toUpperCase() + userObj.state.slice(1)) || ''
        );
        this.city.setValue(
          (userObj.city &&
            userObj.city[0] &&
            userObj.city[0].toUpperCase() + userObj.city.slice(1)) ||
            ''
        );
        this.zipcode.setValue(userObj.zipcode);
      },
      () => {
        this.toastr.error('Something went wrong reading your user information', 'Oops!');
      }
    );
  }

  // TO GET ALL SAVED COMPANIES FROM DB AND SHOW THEM
  showCompanies() {
    this.companyService.getCompanies(this.currentUser).subscribe(
      (data) => {
        this.companyArray = data.data;
        for (let i = 0; i < this.companyArray.length; i++) {
          this.projectService.getProjects(this.companyArray[i]._id).subscribe((projects) => {
            projects.data.forEach((element) => {
              this.budgetService.getBudget(element._id).subscribe((res) => {
                element.total_square_feet = res.data[0].total_square_feet
                  ? res.data[0].total_square_feet
                  : 0;
                element.real_estate_purchase_price = res.data[0].real_estate_purchase_price
                  ? res.data[0].real_estate_purchase_price
                  : 0;
              });
            });
            this.companyArray[i].projects = projects.data;
          });
        }
      },
      () => {
        this.toastr.error('Something went wrong getting the companies', 'Oops!');
      }
    );
  }

  // TO OPEN COMANY MODEL TO SAVE/UPDATE COMPANY LOGO
  openCompanyModal(Id: string, fieldName: string) {
    if (fieldName === 'company') {
      this.companyId = Id;
    } else if (fieldName === 'project') {
      this.projectId = Id;
    }
    this.companyModal.open(Id, fieldName);
  }

  // TO ADD A NEW ENTRY IN COMPANY TABLE(ADD NEW COMPANY IN DB). USER CAN MAXIMUM ADD 3 COMPANIES
  showAddCompany() {
    const data = { userId: this.currentUser };
    this.companyService.saveCompany(data).subscribe(
      (companyData) => {
        if (companyData.messageId === 200) {
          this.showCompanies();
        } else if (companyData.messageId === 400) {
          // TODO: We need to be able to handle all error messages in the error handler.
          this.toastr.error(companyData.message, 'Error!');
        } else {
        }
      },
      () => {
        this.toastr.warning('You can add only three companies.', 'Alert!');
      }
    );
  }

  // TO UPDATE USER DATA FIELDS ONCHANGE AND SAVE THEM INTO DB TOO
  onUpdateUser(event) {
    const fieldName = event.target.name;
    const { value } = event.target;
    if (
      (fieldName === 'firstname' && this.firstname.invalid) ||
      (fieldName === 'lastname' && this.lastname.invalid) ||
      (fieldName === 'email' && this.email.invalid) ||
      (fieldName === 'state' && this.state.invalid) ||
      (fieldName === 'city' && this.city.invalid)
    ) {
      if (fieldName === 'email' && this.email.invalid) {
        this.email.setValue('');
      }
    } else {
      const data = { fieldName, value };
      this.homeService.updateUser(data).subscribe(
        (res) => {},
        () => {
          // TODO: Does the API return any relevant information we can display?
          this.toastr.error('Something is wrong!', 'Oops!');
        }
      );
    }
    // this.getUserData();
  }

  // TO UPDATE PROJECT NAME/COMPANY NAME ONCHANGE AND SAVE THEM INTO DB TOO
  onUpdate(company, fieldName, event) {
    let value;
    if (event.target.value === '') {
      value = event.target.value;
    } else {
      value = event.target.value[0].toUpperCase() + event.target.value.slice(1);
    }

    if (fieldName === 'projectname') {
      const data = {
        projectName: value,
        userName: this.firstname.value,
        email: this.email.value,
        phone: this.phone.value,
      };

      this.projectService.saveProject(company._id, data).subscribe(
        (projectData) => {
          if (projectData.messageId === 200) {
            localStorage.setItem('projectId', projectData.data._id);
            localStorage.setItem('companyId', company._id);
            this.projectId = localStorage.getItem('projectId');
            this.projectService.saveProjectBasic(projectData.data._id).subscribe(() => {});

            this.projectService.addYearlyRecord(projectData.data._id).subscribe(() => {});

            this.EnterpriseService.save(projectData.data._id).subscribe(() => {});
            let data = {}; // TODO: Possible bug here because 'data' is a shadowed variable here. It's defined above.
            this.budgetService.saveBudget(projectData.data._id, data).subscribe(() => {});
            data = { value: projectData.data.company_name };
            this.shareholderService.saveShareholder(projectData.data._id, data).subscribe(() => {});
            this.showCompanies();
          } else if (projectData.messageId === 401) {
            // TODO: First, 401 is the wrong code for this. Second, any other errors should surface correctly.
            this.toastr.error('Please Add Company Name First', 'Error!');
          }
        },
        (err) => this.toastr.error('Please Add Company Name First', 'Error!')
      );
    } else if (fieldName === 'companyname') {
      // TODO: Another redefinition of "data"
      const data = { fieldName: 'companyname', value: event.target.value };
      this.companyService.updateCompany(company._id, data).subscribe(
        (companyData) => {
          if (companyData.messageId === 200) {
          } else if (companyData.messageId === 401) {
            // TODO: Can the API still cause this? The 401 is wrong, and any error should surface correctly.
            this.toastr.error(companyData.message, 'Error!');
          } else {
          }
        },
        () => {
          this.toastr.error('Something is wrong!', 'Oops!');
        }
      );
    }
  }

  // WHEN CLICKED ON ANY PROJECT, THEN TO PROCEED TO NEXT(PROJECT DATA) PAGE BY SETTING IDS INTO LOCAL STORAGE
  next(projectId: string, companyId: string) {
    localStorage.removeItem('select-page');
    localStorage.removeItem('projectId');
    localStorage.removeItem('companyId');
    localStorage.removeItem('projectDetails');
    localStorage.removeItem('companyDetails');

    localStorage.setItem('companyId', companyId);
    localStorage.setItem('projectId', projectId);

    const data = { project_id: projectId, company_id: companyId };
    this.homeService.updateProjectDetails(data).subscribe(() => {});

    this.router.navigate(['/projectdata']);
  }

  // TO DELETE COMPANY WITH ALL OF ITS PROJECTS WHEN CLICKED ON TRASH BUTTON OF COMPANY
  removeCompany(company: any) {
    const companyname = company.companyname ? company.companyname : 'company';
    if (
      confirm(
        `Are you sure you want to delete ${companyname}? Deleting this company will delete all data associated with this company.`
      )
    ) {
      this.companyService.deleteComapny(company._id).subscribe(() => {
        localStorage.removeItem('select-page');
        localStorage.removeItem('projectId');
        localStorage.removeItem('companyId');
        this.showCompanies();
      });
    }
  }

  // TO DELETE PROJECT WHEN CLICKED ON TRASH BUTTON OF PROJECT
  removeProject(project: any) {
    if (confirm(`Are you sure you want to delete ${project.project_name}?`)) {
      this.projectService.deleteProject(project._id).subscribe(() => {
        localStorage.removeItem('select-page');
        localStorage.removeItem('projectId');
        localStorage.removeItem('companyId');
        this.showCompanies();
      });
    }
  }

  // *************PROJECT EDIT TAKS *************/
  // TO EDIT PROJECT NAME
  editProject(project: any) {
    this.isEdit = project._id;
    setTimeout(function () {
      document.getElementById('label').focus();
    }, 100);
  }

  updateProject(project: any) {
    this.isEdit = null;
    const data = { fieldName: 'projectName', value: project.project_name };
    this.projectService.onChangeProject(project._id, data).subscribe(() => {});
  }

  closeEdit($event: any) {
    this.isEdit = null;
    $event.preventDefault();
  }
  // ##############END OF PROJECT EDIT TASKS###############//

  copyProject(project: any) {
    this.projectService.copyProject(project._id).subscribe(
      () => this.showCompanies(),
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          //          console.log('An error occurred:', err.error.message);
          this.toastr.warning(
            `A browser or network error occurred. Please try again.<br /><br />Error message:<br />${err.error.message}`,
            null,
            { enableHTML: true }
          );
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          //
          // err.error is the JSON that was returned from the API.
          //          console.log(`Backend returned code ${err.status}, body was: ${JSON.stringify(err.error)}`);
          this.toastr.error(err.error.message, 'Error');
        }
      }
    );
  }

  // Open instructions in the nav bar when click on instructions button on header bar
  openModal() {
    if (this.showInstructions === true) {
      this.showInstructions = false;
    } else if (this.showInstructions === false) {
      this.showInstructions = true;
    }
  }

  // Close instructions in the nav bar when click on return button on header bar
  closeInstructions() {
    this.showInstructions = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts